import { Component, Input, ElementRef } from '@angular/core';
import {ScreenSizeService } from "../../../../core/services/screen-size.service";
import { ViewEncapsulation } from '@angular/core';
import {Router} from '@angular/router';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/throttleTime';
import { EventsService } from "../../../../core/services/events.service";
import { POPUP_VISIBILITY_HAS_CHANGED } from "../../../../app.constants";


@Component({
    selector: 'product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ProductCardComponent {
    @Input() productCard: any;

    constructor(private screenSizeService: ScreenSizeService,
                private router: Router,
                private eventsService: EventsService,
                private elementRef: ElementRef) {}

    mouseEnter(event) {
        if (this.screenSizeService.isSmall()) {
            return;
        }
        const coordinates = this.elementRef.nativeElement.getBoundingClientRect();
        this.eventsService.trigger(POPUP_VISIBILITY_HAS_CHANGED, { 'display': true,
            'productCard': this.productCard,
            'clientX': coordinates.left + pageXOffset,
            'clientY': coordinates.top + pageYOffset
        });
    }

    mouseLeave(event: MouseEvent) {
        if (this.screenSizeService.isSmall()) {
            return;
        }
        this.eventsService.trigger(POPUP_VISIBILITY_HAS_CHANGED, { 'display': false,
            'productCard': null,
            'clientX': null,
            'clientY': null
        });
    }

    backgroundImage() {
        let url = '';
        if (this.productCard.images['264x179']) {
            url = this.productCard.images['264x179'];
        } else {
            url = "/assets/img/logo-template.png";
        }
        return `url(${url})`;
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/home/components/product-card/product-card.component.ts